import { useEffect, useState } from "react";
import { MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const D = 0.004;
const embed = ({ lat, lon }) => `https://www.openstreetmap.org/export/embed.html?bbox=${lon - D},${lat - D},${lon + D},${lat + D}&layer=mapnik&marker=${lat},${lon}`;

export const SiteMap = ({ wo }) => {
  const [geo, setGeo] = useState(null);
  const addr = wo.service_address;
  useEffect(() => {
    if (addr) api.get(`/work-orders/${wo.id}/geocode`).then((r) => setGeo(r.data)).catch(() => setGeo({ found: false }));
  }, [wo.id, addr]);
  if (!addr) return null;
  const q = encodeURIComponent(addr);
  return (
    <div className="mt-3 space-y-2" data-testid="tech-site-map">
      {geo?.found && <div className="overflow-hidden rounded-lg border border-border">
        <iframe title="Mapa del sitio" src={embed(geo)} loading="lazy" className="pointer-events-none h-44 w-full" data-testid="tech-site-map-frame" />
      </div>}
      {geo && !geo.found && <p className="text-xs text-muted-foreground" data-testid="tech-site-map-unavailable">No fue posible ubicar la dirección en el mapa. Usa los botones para buscarla en Google Maps.</p>}
      <div className="grid grid-cols-1 gap-2 min-[400px]:grid-cols-2">
        <Button variant="outline" className="h-12 border-primary/40 font-semibold" asChild data-testid="tech-maps-button">
          <a href={`https://www.google.com/maps/search/?api=1&query=${q}`} target="_blank" rel="noopener noreferrer"><MapPin className="mr-2 h-4 w-4 text-primary" />Abrir en Google Maps</a>
        </Button>
        <Button variant="outline" className="h-12 border-primary/40 font-semibold" asChild data-testid="tech-directions-button">
          <a href={`https://www.google.com/maps/dir/?api=1&destination=${q}`} target="_blank" rel="noopener noreferrer"><Navigation className="mr-2 h-4 w-4 text-primary" />Cómo llegar</a>
        </Button>
      </div>
    </div>
  );
};
